import { api } from './axios';
import type { Result, SaveResultRequest, OverallRanking, CompetitionPublic } from '../types/results';
import type { Team } from '../types/domain';

export const resultsApi = {
  saveResult: (req: SaveResultRequest) => api.post<Result>('/recorder/results', req).then((r) => r.data),
  deleteResult: (id: number) => api.delete(`/recorder/results/${id}`),
  listByCompetition: (competitionId: number) =>
    api.get<Result[]>(`/admin/competitions/${competitionId}/results`).then((r) => r.data),
  updateCompletedAt: (id: number, completedAt: string) =>
    api.patch<Result>(`/admin/results/${id}/completed-at`, { completedAt }).then((r) => r.data),
};

export interface LandingCompetition {
  shortCode: string;
  name: string;
  unitName: string | null;
  unitSlug: string | null;
  competitionDate: string;
  location: string | null;
  teamCount: number;
  winnerTeamName: string | null;
  winnerCategoryName: string | null;
}

export interface PublicLanding {
  liveCompetitions: LandingCompetition[];
  recentFinished: LandingCompetition[];
}

export const publicApi = {
  competitionDetail: (shortCode: string) =>
    api.get<CompetitionPublic>(`/public/competitions/${shortCode}`).then((r) => r.data),
  results: (shortCode: string) =>
    api.get<Result[]>(`/public/competitions/${shortCode}/results`).then((r) => r.data),
  teams: (shortCode: string) =>
    api.get<Team[]>(`/public/competitions/${shortCode}/teams`).then((r) => r.data),
  overall: (shortCode: string) =>
    api.get<OverallRanking[]>(`/public/competitions/${shortCode}/overall`).then((r) => r.data),
  boardLookup: (boardToken: string) =>
    api
      .get<{ shortCode: string }>(`/public/competitions/board/${boardToken}`)
      .then((r) => r.data),
  landing: () => api.get<PublicLanding>('/public/landing').then((r) => r.data),
};
